import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DisplayLanguageSettingComponent } from '../display-language-setting/display-language-setting.component';
import { PreferencesService } from '../../../../services/preferences/preferences.service';
import { Preferences } from '../../../../models/dtos';
import { CommonDataService } from '../../../../services/common-data.service';

@Component({
  selector: 'app-language-setting',
  imports: [
    MatButton,
    MatFormFieldModule,
    CommonModule,
    MatSelectModule,
    TranslatePipe
  ],
  templateUrl: './language-setting.component.html',
  styleUrl: './language-setting.component.scss'
})
export class LanguageSettingComponent implements OnInit{

  selectedLanguage: string = 'en-US';
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public translate: TranslateService,
    private readonly dialog: MatDialog,
    private readonly preferencesService: PreferencesService,
    private readonly commonDataService: CommonDataService,
  ) {
  }

  ngOnInit(): void {
    const preferenceData = this.commonDataService.getPreferenceData()?.preferences;
    if(preferenceData && preferenceData.cultureString){
      this.selectedLanguage = preferenceData.cultureString;
    }
  }

  saveLanguagePreference(): void {
    this.dialog.open(DisplayLanguageSettingComponent, {
      width: '500px',
      disableClose: true
    });
    
    const preferenceData = this.commonDataService.getPreferenceData()?.preferences;
    preferenceData.cultureString = this.selectedLanguage;
    const requestBody: Preferences = preferenceData;
    this.preferencesService.saveUserPreferenceData(requestBody);
  }

  resetLanguageSelection() {
    this.selectedLanguage = this.translate.currentLang || this.selectedLanguage;
  }

  onCancel(){
    this.cancel.emit();
  }

}
